// Theme Colors
// Initially this will be blank. Later on when app is initialized we will assign bootstrap colors to this from CSS variables.
export const $themeColors = {};

// App Breakpoints
// Initially this will be blank. Later on when app is initialized we will assign bootstrap breakpoints to this object from CSS variables.
export const $themeBreakpoints = {};

// APP CONFIG
export const $themeConfig = {
  app: {
    appName: "安新建經", // Will update name in navigation menu (Branding)
    // eslint-disable-next-line global-require
    appLogoImage: require("@/assets/images/logo/logo.png"),
    bLogoImage: require("@/assets/images/logo/logob.png"),
    pdfimage: require("@/assets/images/icons/icon_pdf.svg"),
    docimage: require("@/assets/images/icons/icon_doc.svg"),
    photoimage: require("@/assets/images/icons/icon_photo.svg"),

    LOGOv: require("@/assets/images/logo/LOGOv.gif"),


    dot_o: require("@/assets/images/icons/dot_o.png"),
    dot_gy: require("@/assets/images/icons/dot_gy.png"),
    icon_paper_gy: require("@/assets/images/icons/icon_paper_gy.svg"),
    icon_paper_b: require("@/assets/images/icons/icon_paper_b.svg"),
  },
  layout: {
    isRTL: false,
    skin: "light", // light, dark, bordered, semi-dark
    routerTransition: "zoom-fade", // zoom-fade, slide-fade, fade-bottom, fade, zoom-out, none
    type: "vertical", // vertical, horizontal
    contentWidth: "full", // full, boxed
    menu: {
      hidden: false,
      isCollapsed: false,
    },
    navbar: {
      // ? For horizontal menu, navbar type will work for navMenu type
      type: "sticky", // static , sticky , floating, hidden
      backgroundColor: "", // BS color options [primary, success, etc]
    },
    footer: {
      type: "static", // static, sticky, hidden
    },
    customizer: true,
    enableScrollToTop: true,
  },
};
